var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMensagemOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.42,
    height: 15.811,
    viewBox: "0 0 16.42 15.811",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85",
    "data-name": "Caminho 85",
    d: "M65.941,68.621h-.75v-.237a1.3,1.3,0,0,1-.23-.2l-1.484-1.673a9.631,9.631,0,0,1-1.917.193h-.01a9.019,9.019,0,0,1-5.711-1.95,6.242,6.242,0,0,1,0-9.99,9.343,9.343,0,0,1,11.424,0,6.244,6.244,0,0,1-.014,10v2.561A1.3,1.3,0,0,1,65.941,68.621ZM64,64.838l1.746,1.969V64.013l.306-.225a5.058,5.058,0,0,0,2.206-4.035,4.946,4.946,0,0,0-1.947-3.833,7.846,7.846,0,0,0-9.525,0,4.746,4.746,0,0,0,0,7.667A7.518,7.518,0,0,0,61.551,65.2h.009a8.128,8.128,0,0,0,2-.25Z",
    transform: "translate(-53.34 -52.81)",
    fill: "#fafafa"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMensagemOn);
export default __webpack_public_path__ + "static/media/ico-mensagem-on.34abd0533692d8a4497ed3afd0175514.svg";
export { ForwardRef as ReactComponent };